export const CHECKOUT_POSTMESSAGE_SOURCE = 'checkout-session-popup';

const PLAN_V1_PATH = '/api/v1/plan';

export const ALL_PLANS_PATH = PLAN_V1_PATH;

const CHECKOUT_PATH = `${PLAN_V1_PATH}/checkout`;
export const CHECKOUT_REDIRECTOR_PATH = `${CHECKOUT_PATH}/checkout-url`;
export const MY_CHECKOUT_URLS_PATH = `${CHECKOUT_PATH}/me`;

const SUBSCRIPTION_PATH = `${PLAN_V1_PATH}/subscription`;
export const MY_SUBSCRIPTION_PATH = `${SUBSCRIPTION_PATH}/me`;
export const EXTERNAL_PAYMENT_PORTAL_LINK_PATH = `${SUBSCRIPTION_PATH}/external-portal-link`;

const USER_PLAN_PATH = `${PLAN_V1_PATH}/user/:userId`;
export const PAYMENT_METHOD_PATH = `${USER_PLAN_PATH}/payment-method`;
export const CUSTOMER_PATH = `${USER_PLAN_PATH}/customer`;

export const MY_COUPONS_PATH = `${PLAN_V1_PATH}/coupon/offer/me`;

const REFERRAL_PATH = `${PLAN_V1_PATH}/referral`;
export const MY_REFERRAL_OWNER_PATH = `${REFERRAL_PATH}/owner/me`;
export const REFERRAL_EMAIL_INVITATION_PATH = `${REFERRAL_PATH}/email-invitation`;

export const PROMOTION_PATH = `${PLAN_V1_PATH}/promotion`;
export const PROMOTION_INFO_PATH = `${PROMOTION_PATH}/:promotionKey`;
export const ACCEPT_PROMOTION_PATH = `${PROMOTION_PATH}/accept`;

export const PODCAST_PROMO_CREDITS_PATH = `${PLAN_V1_PATH}/podcast-promo/credits`;
